import { HugeiconsIcon } from "@hugeicons/react"
import {
  AlignLeftIcon,
  AlignHorizontalCenterIcon,
  AlignRightIcon,
  AlignTopIcon,
  AlignVerticalCenterIcon,
  AlignBottomIcon,
} from "@hugeicons/core-free-icons"
import type { IconSvgElement } from "@hugeicons/react"
import type { CompositorTransform, CompositorCanvas } from "@/lib/types/compositor"
import { cn } from "@/lib/utils"

interface AlignmentButtonsProps {
  transform: CompositorTransform
  canvas: CompositorCanvas
  onAlign: (patch: Partial<CompositorTransform>) => void
}

type PatchFn = (t: CompositorTransform, c: CompositorCanvas) => Partial<CompositorTransform>

const ALIGNMENTS: { icon: IconSvgElement; title: string; patch: PatchFn }[] = [
  { icon: AlignLeftIcon, title: "Align left", patch: () => ({ x: 0 }) },
  { icon: AlignHorizontalCenterIcon, title: "Center H", patch: (t, c) => ({ x: (c.width - t.width) / 2 }) },
  { icon: AlignRightIcon, title: "Align right", patch: (t, c) => ({ x: c.width - t.width }) },
  { icon: AlignTopIcon, title: "Align top", patch: () => ({ y: 0 }) },
  { icon: AlignVerticalCenterIcon, title: "Center V", patch: (t, c) => ({ y: (c.height - t.height) / 2 }) },
  { icon: AlignBottomIcon, title: "Align bottom", patch: (t, c) => ({ y: c.height - t.height }) },
]

export function AlignmentButtons({ transform, canvas, onAlign }: AlignmentButtonsProps) {
  return (
    <div className="grid grid-cols-3 gap-1">
      {ALIGNMENTS.map(({ icon, title, patch }) => (
        <button
          key={title}
          title={title}
          onClick={() => onAlign(patch(transform, canvas))}
          className={cn(
            "flex items-center justify-center h-7 rounded border border-border/50 hover:bg-accent hover:border-border transition-colors"
          )}
        >
          <HugeiconsIcon icon={icon} size={13} className="text-muted-foreground" />
        </button>
      ))}
    </div>
  )
}
